module.exports = __webpack_public_path__ + "img/app4.8107d609.png";